﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "./Model";
//-------------------------------------------------------------------------------------
// Constants
//-------------------------------------------------------------------------------------

const uri = "api/account/v1/users/confirm-phone";
const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface PostConfirmPhoneProps extends api.ApiHookBaseProps<
    accountModel.PostConfirmPhoneRequest,
    unknown,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useAccountPostConfirmPhone(
    props: PostConfirmPhoneProps
): [boolean, (data: accountModel.PostConfirmPhoneRequest) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        accountModel.PostConfirmPhoneRequest,
        unknown,
        unknown
    > = {
        ...props,
        uri: uri,
        method: method,
        skipResponseParsing: true,
    };

    const [loading, invoker] = api.useApi<
        accountModel.PostConfirmPhoneRequest,
        unknown,
        unknown
    >(apiParams);
    return [loading, (data) => invoker(apiParams.uri, data)];
}
